<label>{{label}}</label>
<mat-form-field appearance="outline" class="w-100">
    <mat-select placeholder="{{placeholder}}" class="deposit-detail-panel" [multiple]="multiple">
        <ng-container *ngIf="bankAccounts && bankAccounts.length">
            <mat-option *ngFor="let account of bankAccounts" (click)="toggleAccount(account)" [value]="selection.isSelected(account)" class="text-muted">
                {{account.friendlyName}}
            </mat-option>
        </ng-container>
    </mat-select>
</mat-form-field>
